import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

import { config } from '../config';


const settings = {
  authority: config.OIDC.authority,
  client_id: config.OIDC.clientID,
  redirect_uri: `${window.location.origin}/auth/callback`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage })
};

const userManager = new UserManager(settings);

export default userManager;
